import { AuthForm } from "@/components/auth/auth-form";
import { usePageTitle } from "@shared/client/view";
import { useT } from "@shared/client/locale";

export default function ForgotPasswordPage() {
  usePageTitle(useT().auth.pageTitles.forgotPassword);
  return <AuthForm mode="forgot" />;
}
